<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Mastitis Goals
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <subsection
        :title="farm.farm_label"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-mastitis_goals`"
        v-for="farm in model.FARMS"
        :key="farm.id"
      >
        <report-comment
          :field_name="`farm_${farm.id}-drycow_mastitis_goals`"
          :model="model.COMMENTS"
          title="Mastitis Goals"
          :heading="false"
        >
        </report-comment>

        <report-comment
          :field_name="`farm_${farm.id}-herd_testing_and_culling`"
          :model="model.COMMENTS"
          title="Herd Testing and Culling"
          :heading="false"
        >
        </report-comment>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'MastitisGoals',
  mixins: [mixin],
  props: ['model'],
}
</script>
